import * as tslib_1 from "tslib";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withProps, toClass } from 'recompose';
import { noop } from 'lodash';
import Button from "../Button";
import RawDropdown from './Dropdown';
import "./DropdownButton.css";

var DropdownButton =
/** @class */
function (_super) {
  tslib_1.__extends(DropdownButton, _super);

  function DropdownButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DropdownButton.prototype.render = function () {
    var _a = this.props,
        blockName = _a.blockName,
        children = _a.children,
        other = tslib_1.__rest(_a, ["blockName", "children"]);

    var Dropdown = toClass(withProps({
      blockName: blockName
    })(RawDropdown));
    return React.createElement(Button, tslib_1.__assign({}, other, {
      blockName: blockName,
      component: Dropdown
    }), children);
  };

  DropdownButton.propTypes = {
    blockName: PropTypes.string,
    className: PropTypes.string,
    options: PropTypes.array,
    disabled: PropTypes.bool,
    children: PropTypes.node,
    onChange: PropTypes.func,
    onFocus: PropTypes.func
  };
  DropdownButton.defaultProps = {
    blockName: 'nx-dropdown-button',
    onFocus: noop,
    className: ''
  };
  return DropdownButton;
}(PureComponent);

export default DropdownButton;

try {
  // @ts-ignore
  DropdownButton.__docgenInfo = {
    "description": "",
    "displayName": "DropdownButton",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}